import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { confirmationAlert, showAlert } from 'utility/SweetAlert'

const InteractorProductPriceListCreate = () => {
  const priceListCreate = useCallback((body, loading) => {
    const payload = {
      ...body,
    }
    confirmationAlert({
      icon: 'question',
      message: getTranslate('message.confirm_process'),
    }).then((result) => {
      if (result === true) {
        ApiService.jsonRequest('/product/price-list/create', payload, (response) => {
          loading(false)
          if (response.code === 7201) {
            showAlert({
              icon: 'success',
              message: getTranslate('message.successfully_created'),
              timer: 2000,
              redirect: '/product/schema/manage',
            })
          } else {
            showAlert({
              icon: 'error',
              message: getMessage(response?.msg),
              timer: 2000,
            })
          }
        })
      } else {
        loading(false)
      }
    })
  }, [])
  return { priceListCreate }
}

export default InteractorProductPriceListCreate
